import { createSelector } from 'reselect';
import populateChannels from 'store/selectors/populateChannels';

export const currentChannel = (channels, currentId) => {
  // A real channel is explicitly selected: return exactly that channel (or
  // undefined if it isn't loaded yet). Never fall back to a *different* channel —
  // doing so silently points the header, composer, and drawers at the wrong
  // conversation when the selected channel is missing from the map (OMM-603).
  // `currentId === 1` is the "no selection" sentinel set after archiving.
  if (currentId && currentId !== 1) return channels[currentId];

  const previousId = localStorage.getItem('currentId');

  if (channels[previousId]) return channels[previousId];

  const firstId = Object.keys(channels)[0];

  return channels[firstId];
};

export default createSelector(
  state => populateChannels(state),
  state => state.elements.ChannelsPanel.currentId,
  currentChannel,
);
